import Vue from "vue";

export default {
	state: {
		integrations: {},
		integration: {},
		requirementResponse: {},
		visibleIntegrationRequirementResponse: {}
	},
	mutations: {
		setIntegrationsOnState(state, integrations) {
			state.integrations = integrations;
		},
		setIntegrationOnState(state, integration) {
			state.integration = integration;
		},
		setVisibleIntegrationRequirementResponseOnState(state, visibleIntegrationRequirementResponse) {
			let isRequirementResponseJSON = Vue.prototype.$functions.isObjectJSON(
				visibleIntegrationRequirementResponse.integration
			);
			let visibleIntegrationRequirementResponses = {};
			let count = 0;

			if (!isRequirementResponseJSON) {
				visibleIntegrationRequirementResponses = { answer: visibleIntegrationRequirementResponse.integration };
			} else {
				try {
					const visibleIntegrationRequirementParsedJSON = JSON.parse(visibleIntegrationRequirementResponse.integration);

					if (visibleIntegrationRequirementParsedJSON && visibleIntegrationRequirementParsedJSON.serasaProdutoRelato) {
						for (const key in visibleIntegrationRequirementParsedJSON.serasaProdutoRelato) {
							if (count >= 14) break;

							visibleIntegrationRequirementResponses[key] =
								visibleIntegrationRequirementParsedJSON.serasaProdutoRelato[key];
							count++;
						}
					}
				} catch (e) {
					console.error(e);
					return;
				}
			}
			state.visibleIntegrationRequirementResponse = visibleIntegrationRequirementResponses;
		},
		setIntegrationRequirementResponseOnState(state, requirementResponse) {
			let isRequirementResponseJSON = Vue.prototype.$functions.isObjectJSON(requirementResponse.integration);
			let parsedJson;

			if (!isRequirementResponseJSON) {
				parsedJson = { answer: requirementResponse.integration };
			} else {
				const removeEmptyItems = (obj) => {
					for (const key in obj) {
						if (typeof obj[key] === "object" && obj[key] !== null) {
							if (Array.isArray(obj[key])) {
								obj[key] = obj[key].filter((item) => {
									if (typeof item === "object" && item !== null) {
										removeEmptyItems(item);
										return Object.keys(item).length > 0;
									}
									return true;
								});
								if (obj[key].length === 0) {
									obj[key] = "N/A";
								}
							} else {
								removeEmptyItems(obj[key]);
								if (Object.keys(obj[key]).length === 0) {
									obj[key] = "N/A";
								}
							}
						} else if (obj[key] === "") {
							obj[key] = "N/A";
						}
					}
				};

				try {
					parsedJson = JSON.parse(requirementResponse.integration);
				} catch (error) {
					console.error(error);
					return;
				}
				removeEmptyItems(parsedJson);
			}

			state.requirementResponse = parsedJson;
		},
		cleanIntegrationRequirementResponse(state) {
			state.requirementResponse = [];
			state.visibleIntegrationRequirementResponse = [];
		},
		cleanIntegration(state) {
			state.integration = [];
		}
	},
	actions: {
		getIntegrations({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("integration")
					.then((response) => {
						commit("setIntegrationsOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getIntegrationById({ commit }, obj) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`integration/${obj.idIntegration}/${obj.idSupplier}`)
					.then((response) => {
						commit("setIntegrationOnState", response.data.data.integration);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getIntegrationRequirementResponse({ commit }, dataObject) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`integration/${dataObject.idRequirement}/${dataObject.idIntegration}/${dataObject.idInvite}`)
					.then((response) => {
						commit("setIntegrationRequirementResponseOnState", response.data.data);
						commit("setVisibleIntegrationRequirementResponseOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		reprocessIntegration(_, input) {
			return new Promise((resolve, reject) => {
				this.state.loading = true;
				Vue.prototype.$http
					.post("integration/reprocess", input)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getReceitaFederalCnpjQsa(_, idSupplier) {
			return new Promise((resolve, reject) => {
				this.state.loading = true;
				Vue.prototype.$http
					.get(`integration/qsa/${idSupplier}`)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		}
	},
	getters: {
		integrations({ integrations }) {
			return integrations;
		},
		integration({ integration }) {
			return integration;
		},
		integrationRequirementResponse({ requirementResponse }) {
			return requirementResponse;
		},
		visibleIntegrationRequirementResponse({ visibleIntegrationRequirementResponse }) {
			return visibleIntegrationRequirementResponse;
		}
	}
};
